module.exports = __webpack_public_path__ + "add896bc8bdfaa9e6bd9a28a458ea311.pdf";